var React = require('react');

function IconReportActivity (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18,0A18,18,0,1,0,36,18,18,18,0,0,0,18,0Zm0,32.57A14.57,14.57,0,1,1,32.57,18,14.58,14.58,0,0,1,18,32.57ZM28.85,17.15,26.11,11.7a1.3,1.3,0,0,0-1.26-.7,1.28,1.28,0,0,0-1.13.89l-2.51,8-2.29-5.66a1.29,1.29,0,0,0-1.2-.8h0a1.29,1.29,0,0,0-1.2.79l-2.28,5.59-1.82-2.57a1.3,1.3,0,0,0-1-.54,1.28,1.28,0,0,0-1,.45L7.3,20.82a1.24,1.24,0,0,0,.17,1.77,1.31,1.31,0,0,0,1.81-.16l2-2.36,2.22,3.14A1.3,1.3,0,0,0,15.76,23l2-4.83,2.45,6.06a1.29,1.29,0,0,0,1.2.8h.05a1.28,1.28,0,0,0,1.18-.89l2.63-8.43,1.3,2.59a1.3,1.3,0,0,0,1.72.58A1.25,1.25,0,0,0,28.85,17.15Z"}));
}

IconReportActivity.defaultProps = {"viewBox":"0 0 36 36"};

module.exports = IconReportActivity;

IconReportActivity.default = IconReportActivity;
